import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    materialList: () => {
        return HTTP.get('/stock/material_all', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    materialMinList: () => {
        return HTTP.get('/stock/material_min', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}